/* global angular */

import './style.less';
import { keyBy } from 'lodash';

export default function($log, ProfileClass, ApiClass, Swal) {
  'ngInject';
  const vm = this;
  vm.$onChanges = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.updateStatus = (emailTemplate, active) => {
    const { course_id, custom_emails, event_id } = vm.event;

    if (!custom_emails[emailTemplate]) return;

    custom_emails[emailTemplate].active = !!active;

    const event = {
      course_id,
      custom_emails,
      event_id
    };

    return ApiClass.eventsIdPatch({ id: event_id, manage: true }, { event })
      .then(() => Swal.toast('Event email template updated!'))
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  /**
   * Deleted templates may still exist on an event, this filters them out.
   *
   * @param {*} companyTemplates
   */
  function _filterObsoleteTemplates(companyTemplates) {
    const companyTemplatesDict = keyBy(companyTemplates, 'id');

    Object.keys(vm.event.custom_emails).forEach(key => {
      if (!(key in companyTemplatesDict)) {
        delete vm.event.custom_emails[key];
      }
    });
  }

  /**
   * Populates the custom email templates with data, overwriting the company templates with any custom data.
   *
   * @param {*} companyTemplates
   */
  function _populateTemplatesList(companyTemplates) {
    if (!vm.event.custom_emails) {
      vm.event.custom_emails = {};
    }

    _filterObsoleteTemplates(companyTemplates);

    companyTemplates.map(({ uuid, ...companyTemplate }) => companyTemplate).forEach(companyTemplate => {
      const eventTemplate =
        companyTemplate.id in vm.event.custom_emails ? vm.event.custom_emails[companyTemplate.id] : { active: false };

      vm.event.custom_emails[companyTemplate.id] = { ...companyTemplate, ...eventTemplate };
    });
  }

  function activate() {
    vm.loaded = false;
    vm.error = {};

    if (!vm.event) return;

    ApiClass.companiesIdTypeGet(
      {
        manage: false,
        id: company_id,
        type: 'emailTemplates'
      },
      null,
      { queryParams: { 'filter:usage': 'events' } }
    )
      .then(({ data: { items: companyTemplates } }) => {
        $log.log('Email Template Component: ', { templates: companyTemplates });
        _populateTemplatesList(companyTemplates);
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/emails/controller.js